import { render, staticRenderFns } from "./NumberDisplay.vue?vue&type=template&id=7c5b4b38&scoped=true"
import script from "./NumberDisplay.vue?vue&type=script&lang=js"
export * from "./NumberDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5b4b38",
  null
  
)

export default component.exports